<template>
<div class="header-bar-full-width">
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
    <div class="row margin-Top-5Perc">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-size-2vw admin-Panel-BG text-align-center">
       {{title}}
      </div> 
    </div> 
  </div>
</div> 
</template>

<script>
export default {
  name: 'header-bar-full-width',
  created () {
    console.log('THIS IS HEADER BAR FULL WIDTH COMP')
  },
  data: function () {
    return {
      title: 'Mentora Admin'
    }
  }
}
</script>

<style scoped>
.width
{
  width: 96%;
}
.header-bar
{
  overflow-y: hidden !important;
}
.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.left-color-border
{
	border: 1px solid red;
}
.right-color-border
{
	border: 1px solid green;
}
.leftNavBarBG
{
	background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px{
	font-size: 30px;
}
.position-Fixed
{
	position:fixed;
}
.float-Right
{
	float: right;
}
.fullHeight
{
	height:100% !important;
}
.fi-border
{
	border: 1px solid white;
}
 .footer-img
 {
    margin: 0 auto !important;
    display: block;
    position: absolute;
    bottom: 0;
	width: 30%;
 }
 .center-block {
   margin-left:auto;
   margin-right:auto;
   display:block;
}
.text-center {
   text-align:center
}
.margin-Top-14Perc
{
	margin-top: 14%;
}
.margin-Top-5Perc
{
	margin-top: 5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.text-align-left
{
  text-align: left;
}
.text-align-center
{
  text-align: center;
}
.margin-Left-4Perc
{
  margin-left: 4%;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
</style>







// WEBPACK FOOTER //
// src/components/HeaderBarFullwidth.vue